// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"_3-G1Ki2","backdropVisible":"_2H6eDim","sidebar":"_3AQNEOU","menuItems":"_3fNKzKy","buttonClose":"_2z-XVrB","sidebarOpen":"_1LwqQ5W","desktopVersionContainer":"IDunwNg"};